 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"he-bei-poster-deal":"he-bei-poster-deal","he-bei-poster-result~jincheng-yibao-area-insu-buy-detail":"he-bei-poster-result~jincheng-yibao-area-insu-buy-detail","he-bei-poster-result":"he-bei-poster-result","jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail":"jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail","jincheng-yibao-BuySuccess":"jincheng-yibao-BuySuccess","jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail":"jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail","jincheng-yibao.policy-detail":"jincheng-yibao.policy-detail","jincheng-yibao-company-appointment":"jincheng-yibao-company-appointment","jincheng-yibao-insu-faq":"jincheng-yibao-insu-faq","jincheng-yibao-privacy-statement":"jincheng-yibao-privacy-statement","jincheng-yibao-area-insu-buy-detail":"jincheng-yibao-area-insu-buy-detail","jincheng-yibao-register-protocol":"jincheng-yibao-register-protocol","jincheng-yibao-user-center":"jincheng-yibao-user-center","jincheng-yibao.user-policy":"jincheng-yibao.user-policy"}[chunkId]||chunkId) + "." + {"chunk-1f446bfe":"d0e848b0","chunk-291fb183":"5bc6d394","chunk-2d0be70b":"b77c718d","chunk-2d0c5587":"4b9ab83c","chunk-2d225096":"2e99c8a2","chunk-368564aa":"75db92c5","chunk-39932879":"cb822c55","chunk-48c9235b":"5fecc1e9","chunk-573034bd":"1bf7cba1","chunk-6d579988":"14e69161","chunk-723bdb24":"0434e292","chunk-7a9ef8ee":"967b2a6a","chunk-b16419c6":"f9e69436","chunk-bce58f5e":"f64c3837","he-bei-poster-deal":"32fb3858","he-bei-poster-result~jincheng-yibao-area-insu-buy-detail":"106a0b9a","he-bei-poster-result":"7516de53","jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail":"395b26c6","jincheng-yibao-BuySuccess":"d56d452f","jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail":"6389467a","jincheng-yibao.policy-detail":"b3844090","jincheng-yibao-company-appointment":"621d208f","jincheng-yibao-insu-faq":"9889bc2f","jincheng-yibao-privacy-statement":"7e7c08ee","chunk-29fb20e0":"9dafb27c","jincheng-yibao-area-insu-buy-detail":"3cd0cc57","jincheng-yibao-register-protocol":"030b90d2","jincheng-yibao-user-center":"7c8e6be7","jincheng-yibao.user-policy":"df7c9f20"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1f446bfe":1,"chunk-291fb183":1,"chunk-368564aa":1,"chunk-39932879":1,"chunk-48c9235b":1,"chunk-573034bd":1,"chunk-6d579988":1,"chunk-723bdb24":1,"chunk-7a9ef8ee":1,"chunk-b16419c6":1,"chunk-bce58f5e":1,"he-bei-poster-deal":1,"he-bei-poster-result":1,"jincheng-yibao-BuySuccess":1,"jincheng-yibao.policy-detail":1,"jincheng-yibao-company-appointment":1,"jincheng-yibao-insu-faq":1,"jincheng-yibao-privacy-statement":1,"chunk-29fb20e0":1,"jincheng-yibao-area-insu-buy-detail":1,"jincheng-yibao-register-protocol":1,"jincheng-yibao-user-center":1,"jincheng-yibao.user-policy":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"he-bei-poster-deal":"he-bei-poster-deal","he-bei-poster-result~jincheng-yibao-area-insu-buy-detail":"he-bei-poster-result~jincheng-yibao-area-insu-buy-detail","he-bei-poster-result":"he-bei-poster-result","jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail":"jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail","jincheng-yibao-BuySuccess":"jincheng-yibao-BuySuccess","jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail":"jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail","jincheng-yibao.policy-detail":"jincheng-yibao.policy-detail","jincheng-yibao-company-appointment":"jincheng-yibao-company-appointment","jincheng-yibao-insu-faq":"jincheng-yibao-insu-faq","jincheng-yibao-privacy-statement":"jincheng-yibao-privacy-statement","jincheng-yibao-area-insu-buy-detail":"jincheng-yibao-area-insu-buy-detail","jincheng-yibao-register-protocol":"jincheng-yibao-register-protocol","jincheng-yibao-user-center":"jincheng-yibao-user-center","jincheng-yibao.user-policy":"jincheng-yibao.user-policy"}[chunkId]||chunkId) + "." + {"chunk-1f446bfe":"4d4eaf54","chunk-291fb183":"39401613","chunk-2d0be70b":"31d6cfe0","chunk-2d0c5587":"31d6cfe0","chunk-2d225096":"31d6cfe0","chunk-368564aa":"5ffa3587","chunk-39932879":"170b0339","chunk-48c9235b":"d96fcc81","chunk-573034bd":"2249eb36","chunk-6d579988":"058264e1","chunk-723bdb24":"1fbb7531","chunk-7a9ef8ee":"e41585c8","chunk-b16419c6":"e0d87120","chunk-bce58f5e":"8b4958ad","he-bei-poster-deal":"b6919ee4","he-bei-poster-result~jincheng-yibao-area-insu-buy-detail":"31d6cfe0","he-bei-poster-result":"59548f13","jincheng-yibao-BuySuccess~jincheng-yibao-area-insu-buy-detail":"31d6cfe0","jincheng-yibao-BuySuccess":"6c4fb7b9","jincheng-yibao-area-insu-buy-detail~jincheng-yibao.policy-detail":"31d6cfe0","jincheng-yibao.policy-detail":"2be528e6","jincheng-yibao-company-appointment":"084a8ef4","jincheng-yibao-insu-faq":"24e03792","jincheng-yibao-privacy-statement":"045dab00","chunk-29fb20e0":"2d21b021","jincheng-yibao-area-insu-buy-detail":"5fd015b3","jincheng-yibao-register-protocol":"ce71e79a","jincheng-yibao-user-center":"09e791d8","jincheng-yibao.user-policy":"856964d4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.baoxian72.com/hunan_mobile_web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
